import React from 'react';
import classByWidth from '../utils/classByWidth';
import styleByName from '../utils/styleByName';

const PageContent = ({ PrismicReact, prismicCtx, data }) => {
	const { title, fields } = data;

	return (
		<div className="page-content-container row">
			<div className="page-content flex-wrap col-lg-8 offset-lg-2 col-md-10 offset-md-1 py-5">
				<h1 className="page-title col-lg-12 mb-4">{PrismicReact.RichText.asText(title)}</h1>

				<div className="fields d-flex flex-wrap align-items-stretch">
					{fields.map(field => (
						<div key={Math.random()} className={`field d-flex align-items-stretch pt-3 mb-2 ${classByWidth(field.width)}`}>
							<div style={styleByName(field.color)} className="field-content d-flex align-items-stretch">
								{PrismicReact.RichText.render(field.content, prismicCtx.linkResolver)}
							</div>
						</div>
					))}
				</div>
			</div>

		</div>
	)
}

export default PageContent;



// WEBPACK FOOTER //
// ./src/components/PageContent.js